<template>
    <div class="user-stat-page-container">
        <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
            <CSpinner
                color="info"
                style="width:4rem;height:4rem;"
            />
        </div>
        <CCard v-else bodyWrapper class="tip_body">
            <div class="username">
                <div class="d-flex" style="color: blue; font-weight: 600;">
                    <Avatar 
                        :key="stat.userAvatar"
                        :size="55"
                        :src="stat.userAvatar"
                        :username="stat.userName"
                        :userId="stat.userId"
                    />
                    &nbsp; <span :class="{'online-mark' : online, 'offline-mark' : !online}" ></span>{{ stat.userName}}
                </div>
            </div>
            <div class="stat">
                <!-- <div class="sub_stat"> -->
                
                <div class="tips">
                    <div>{{ $t('Tips') }}</div>
                    <div>{{ stat.total_tips}}<span v-if="userId == 0">({{ real_stat.total_tips }})</span></div>
                </div>
                <div class="profit-pts">
                    <div>{{ $t('Profit PTs') }}</div>
                    <div :class="{
                        'limegreen': stat.profit_pts >= 0,
                        'red': stat.profit_pts < 0}">
                        {{ stat.profit_pts}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.profit_pts >= 0,
                            'red': real_stat.profit_pts < 0}">
                            ({{ real_stat.profit_pts }})
                        </span>
                    </div>                    
                </div>
                <div class="roi">
                    <div>{{ $t('ROI %') }}</div>
                    <div :class="{
                        'limegreen': stat.roi >= 0,
                        'red': stat.roi < 0}">
                        {{ stat.roi}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.roi >= 0,
                            'red': real_stat.roi < 0}">
                            ({{ real_stat.roi }})
                        </span>
                    </div>
                </div>
                <div class="w-rate">
                    <div>{{ $t('W/Rate') }}</div>                    
                    <div :class="{
                        'limegreen': stat.w_rate >= 0,
                        'red': stat.w_rate < 0}">
                        {{ stat.w_rate}}
                        <span  v-if="userId == 0" :class="{
                            'limegreen': real_stat.w_rate >= 0,
                            'red': real_stat.w_rate < 0}">
                            ({{ real_stat.w_rate }})
                        </span>
                    </div>
                </div>
                <div class="w-rate">
                    <div>{{ $t('Avg Odd') }}</div>                    
                    <div>
                        
                        {{ stat.avg_odd}} 
                        <span  v-if="userId == 0">
                            ({{ real_stat.avg_odd }})
                        </span>
                        
                    </div>
                </div>
                <div class="followers">
                    <div class="followers">
                    <div>Followers</div>
                    
                    <div class="action-box" :key="stat.followers">
                        <div :class="{
                                'action': true,
                                'selected': userIsFollowed
                            }">
                            {{ stat.followers}}
                            <span v-if="$route.params.id != loggedInUser.user_id"
                                v-c-tooltip="userIsFollowed ? $t('You already followed this tipster') : $t('Follow this tipster')"
                                @click="handleFollowUser_($route.params.id, loggedInUser.user_id)">
                                <CIcon name="cil-user-follow" />
                            </span>
                            <span v-else>
                                <CIcon name="cil-user-follow" class="disabled" />
                            </span>
                        </div>
                    </div>
                    
                </div>
                </div>
                
            <!-- </div> -->
            </div>
            <CTabs>
                <CTab :title="$t('My tips')">
                    <CCallout color="warning">
                        <strong class="h2">{{ $t('Pending Tips') }}</strong> - 
                        <span class="text-muted h4">{{data.filter(item => !item.settled).length}}</span>
                    </CCallout>
                    <div :key="item._id" v-for="(item, index) in unSettledList" class="feed_card">
                    
                        <post-card 
                            :key="item._id"
                            :index="index"
                            :item="item"
                            :loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 0)"
                            :cover_loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 1)"
                            :unread="!!notifications.find(nItem => nItem.tipId === item._id && !nItem.commentId && !nItem.readAt)"
                            :handleLikeTip="handleLikeTip"
                            :handleFollowTip="handleFollowTip"
                            :handleFollowUser="handleFollowUser"
                            :handleFollowStrategy="handleFollowStrategy"
                            :handlePostComment="handlePostComment"
                            :handleSelectReply="handleSelectReply"
                            :onCashOut="handleCashOut"
                            :trends_flag="false"
                            :handleDeleteTip="handleDeleteTip"
                            :handleDeleteComment="handleDeleteComment"
                        />
                    </div>
                    <CCallout color="success">
                        <strong class="h2">{{ $t('Settled Tips') }}</strong> - 
                        <span class="text-muted h4">{{data.filter(item => item.settled).length}}</span>
                    </CCallout>
                    <div :key="item._id" v-for="(item, index) in settledList" class="feed_card">

                        <post-card 
                            :key="item._id"
                            :index="index"
                            :item="item"
                            :loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 0)"
                            :cover_loading="!!cashoutQueue.find(nItem => nItem._id === item._id && nItem.cashout_type === 1)"
                            :unread="!!notifications.find(nItem => nItem.tipId === item._id && !nItem.commentId && !nItem.readAt)"
                            :handleLikeTip="handleLikeTip"
                            :handleFollowTip="handleFollowTip"
                            :handleFollowUser="handleFollowUser"
                            :handleFollowStrategy="handleFollowStrategy"
                            :handlePostComment="handlePostComment"
                            :handleSelectReply="handleSelectReply"
                            :onCashOut="handleCashOut"
                            :trends_flag="true"
                            :handleDeleteTip="handleDeleteTip"
                            :handleDeleteComment="handleDeleteComment"
                        />
                    </div>
                    <div v-if="stat.total_tips > data.length" style="text-align: center;">
                        <CButton color="dark" class="align-items-center" @click="loadMore(settledList.length)" :disabled="loadmore_loading">
                            Load more
                            <CSpinner v-if="loadmore_loading" color="danger" size="sm" />
                        </CButton>
                    </div>
                </CTab>
                <CTab :title="$t('Strategies')">
                    <template v-if="userId === stat.userId">
                        <h4 class="my-4">{{ $t('Create a strategy') }}:</h4>
                        <CInput
                            label="Name:"
                            :placeholder="$t('e.g.strategy 43')"
                            :value.sync="name"
                            :horizontal="{ label: 'col-sm-1', input: 'col-sm-11'}"
                        />
                        <CTextarea
                            rows="3"
                            :label="$t('Description')"
                            :placeholder="$t('e.g.This strategy is for testing over 2.5 at half time when the home team is leadig at half time')"
                            :value.sync="description"
                            :horizontal="{ label: 'col-sm-1', input: 'col-sm-11'}"
                        />
                        <div class="text-right">
                            <CButton color="primary" @click="handleCreate" :disabled="!name || !description">
                                {{ $t('Create') }}
                            </CButton>
                        </div>
                        <hr />
                    </template>
                    
                    <h4 class="my-4">{{ $t('Strategy list') }}:</h4>
                    <ListTable 
                        :key="`${strategies.length}${refreshKey}`"
                        :loading="loading"
                        :items="strategies" 
                        :fields="columns" 
                        :showPagination="false"
                        :strRefreshKey="refreshKey_strategy"
                        :membership_ids="membership_id_list"
                    />
                    <b-modal 
                        ref="edit_strategy"                        
                        title="Edit Strategy!"
                        @ok="handleOk"
                        @cancel="handleCancel"
                        >                       
                        <div class="form-group ">
                            <label style="float: left;  margin-right: 5px;">Name</label>
                            <CInput 
                                :value.sync="edit_name"
                            />
                        </div>
                        <div class="form-group">
                            <label style="float: left;  margin-right: 5px;">Description</label>
                            <CTextarea 
                                :value.sync="edit_description"
                            />
                        </div>
                        <template #modal-footer="{ ok, cancel }">
                            <b-button size="sm" variant="success":disabled="!edit_name || !edit_description"  @click="ok()">
                                {{ $t('OK') }}
                            </b-button>
                            <b-button size="sm" variant="danger" @click="cancel()">
                                {{ $t('Cancel') }}
                            </b-button> 
                        </template>
                    </b-modal>
                    <b-modal 
                        ref="exclude_users"                        
                        title="Subscr ID"
                        @ok="handleOk_excludeUsers"
                        @cancel="handleCancel_excludeUsers"
                        >                       
                        <div class="form-group ">
                            <label style="float: left;  margin-right: 5px;">{{ user_exclude_strategyName }}</label>
                            
                        </div>
                        <div class="form-group" style="padding-top: 20px;">
                            <!-- <div>
                              <b-form-checkbox
                                    v-for="option in membership_setting"                  
                                    v-model="option.value"                                    
                                    :name="option.name.toString()"
                                    inline
                              >
                                    {{ option.name }}
                              </b-form-checkbox>
                            </div> -->
                            
                            <div>
                                <label style="display: block;">sospesosoftware.com</label>
                                <b-form-checkbox
                                    v-if="option.name < 1000"
                                    v-for="option in membership_setting"
                                    v-model="option.value"
                                    :name="option.name.toString()"
                                    inline
                                >
                                  {{ option.name }}
                                </b-form-checkbox>
                            </div>
                            <div style="padding-top: 10px;">
                                <label style="display: block;">goaltraders.com.br</label>
                                <b-form-checkbox
                                    v-if="option.name >= 1000 && option.name < 2000"
                                    v-for="option in membership_setting"
                                    v-model="option.value"
                                    :name="option.name.toString()"
                                    inline
                                >
                                  {{ option.name }}
                                </b-form-checkbox>
                            </div>
                            <div style="padding-top: 10px;">
                                <label style="display: block;">goaltraders.it</label>
                                <b-form-checkbox
                                    v-if="option.name >= 3000 && option.name < 4000"
                                    v-for="option in membership_setting"
                                    v-model="option.value"
                                    :name="option.name.toString()"
                                    inline
                                >
                                  {{ option.name }}
                                </b-form-checkbox>
                            </div>
                            <div style="padding-top: 10px;">
                                <label style="display: block;">sospesosoftwares.com.br</label>
                                <b-form-checkbox
                                    v-if="option.name >= 5000"
                                    v-for="option in membership_setting"
                                    v-model="option.value"
                                    :name="option.name.toString()"
                                    inline
                                >
                                  {{ option.name }}
                                </b-form-checkbox>
                            </div>
                        </div>
                        <div class="form-group">
                            select allowed subscriptions ID
                        </div>
                        <!-- <div class="form-group">
                            <label>1: sospesosoftware.com</label>
                            <label style="padding-left: 20px">1000: goaltraders.com.br</label>
                            <label style="padding-left: 20px">3000: goaltraders.it</label>
                            <label style="padding-left: 20px">5000: sospesosoftwares.com.br</label>
                        </div> -->
                        <template #modal-footer="{ ok, cancel }">
                            <b-button size="sm" variant="success" @click="ok()">
                                {{ $t('OK') }}
                            </b-button>
                            <b-button size="sm" variant="danger" @click="cancel()">
                                {{ $t('Cancel') }}
                            </b-button> 
                        </template>
                    </b-modal>
                </CTab>
                <CTab :title="$t('Stats')">
                    <StatsTable 
                        :items1="stats1"
                        :items2="stats2"

                    />
                </CTab>
                <CTab v-if="userId === stat.userId" :title="$t('Options')">
                    <div style="padding-top: 15px; padding-left: 15px">
                        <h5> {{ $t('Reset details') }}</h5>
                        
                        <div class="resetCount" style="padding-top: 10px;padding-bottom: 10px">
                            <div>{{ $t('Reset Count') }}: {{ stat.resetCount}}</div>
                            
                        </div>
                        <CButton                            
                            color="info"
                            @click="handleReset"
                            style="background-color: #3399ff;">
                            {{ $t('Reset stat') }}
                        </CButton>
                    </div>
                </CTab>
            </CTabs>
        </CCard>
        
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';

    import Avatar from '@/components/Avatar';
    import PostCard from '@/components/PostCard';
    import ListTable from '@/components/ListTable';
    import StatsTable from '@/components/StatsTable';

    import commonMixin from '@/mixins/common/commonMixin';
    import tipMixin from '@/mixins/TipMixin';
    import {capitalizeFL} from '@/helpers/string';
    import {displaySuccess, displayError} from '@/helpers/message';
    import {convertUTCToLocal, defaultFormat } from '@/helpers/time';

    export default {
        name: 'PostTip',
        mixins: [commonMixin, tipMixin],
        components: {
            Avatar,
            PostCard,
            ListTable,
            StatsTable
        },
        data () {
            return {
                data: [],
                userId: '',
                paramId: '',
                stat: {
                    userName: '',
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    followers: '',
                    resetCount: 0,
                    avg_odd: 0
                },
                real_stat: {                    
                    total_tips: 0,
                    roi:  0,
                    profit_pts: 0,
                    w_rate: 0,
                    avg_odd: 0                   
                },
                notifications: [],
                name: '',
                description: '',
                strategies: [],
                refreshKey: 0,
                refreshKey_strategy: 0,
                refreshCashoutKey: 0,
                cashOutTimer: null,
                stats1: [],
                stats2: [],
                loadmore_loading: false,

                edit_name: '',
                edit_description: '',
                strategyId: '',
                userIsFollowed: false,
                online: false,
                membership_id_list: [],
                membership_setting: [],
                user_exclude_strategyName: "",
                user_exclude_strategyId: ""
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            columns() {
                return [
                    { key: 'name', label: this.$t('Name') },
                    { key: 'total_tips', label: this.$t('Total Tips'), _style:'' },
                    { key: 'pending_tips', label: this.$t('Pending Tips'), _style:'' },                    
                    { key: 'profit_pts', label: this.$t('Pts'), _style:'' },
                    { key: 'roi', label: this.$t('ROI%'), _style:'' },
                    { key: 'w_rate', label: this.$t('W/rate'), _style:'' },
                    { key: 'avg_odd', label: this.$t('Avg Odd'), _style:'' },
                    { key: 'strategy_followers', label: this.$t('Followers'), _style:'' },
                    { key: 'strategy_info', label: this.$t('Info'), _style:'' },
                    { key: 'actions', label: 'actions' },
                ];
            },
            settledList(){
                let _data = this.data.filter(item => !!item.settled);
                console.log('this.data.length', this.data.length)
                return [..._data];


            },
            unSettledList(){
                let _data = this.data.filter(item => !item.settled);
                return [..._data];
            }
        },
        methods: {
            ...mapActions([
                'getFeedsByUserId',
                'getFeedsByUserId_',
                'getStatsByUserId',
                'postComment',
                'resetTip',
                'toggleLikeTip',
                'toggleFollowTip',
                'toggleFollowUser',
                'toggleFollowStrategy',
                'strategySwitch',
                'strategyBetfairSwitch',
                'strategyTelegramSwitch',
                'createStrategy',
                'deleteStrategy',
                'getUserStrategies',
                'getMyPendingFeeds',
                'cashOut',
                'postCashoutRef',
                'deleteTip',
                'deleteComment',
                'editStrategy',
                'deleteEventsByStrategy',
                'strategyExcludeStats',
                'strategyExcludeUsers',
                'membership_ids'
            ]),


            handleDeleteTip(tip_id) {
                
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteTip({tip_id: tip_id}).then((data) => {
                                let idx = this.data.findIndex(item => item._id === tip_id);
                                this.data.splice(idx, 1);

                                
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },

            handleDeleteComment(tip_id, comment_id) {
                
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteComment({comment_id: comment_id}).then((data) => {
                                let idx = this.data.findIndex(item => item._id === tip_id);

                                let comment_idx = this.data[idx].comments.findIndex(item => item._id === comment_id)
                                this.data[idx].comments.splice(comment_idx, 1);

                                
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },

            loadMore(numberOfItems) {
                this.loadmore_loading = true;
                console.log(numberOfItems)
                this.getFeedsByUserId_({id: parseInt(this.paramId), num: parseInt(numberOfItems)}).then(({data: {feeds}}) => {
                    
                    feeds.sort((a, b) => {
                        return Math.abs(a.settled) - Math.abs(b.settled);
                    });

                    console.log('feeds', feeds)
                    feeds.forEach(fItem => {
                        if (this.loggedInUser.user_id !=0 && fItem.strategyData && fItem.strategyData.hide === true) {
                            
                        }
                        else {
                            let fIndex = this.data.findIndex(item => item._id === fItem._id);                            
                            if (fIndex < 0)
                                this.data.push(this.makeFeed(fItem));

                        }

                        
                    });
                }).finally(() => {
                    this.loadmore_loading = false;
                });
            },
            handleReset() {
                Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, reset it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            let user_id = localStorage.getItem('user_id');
                            this.resetTip({user_id}).then(({status}) => {
                                if(status === 'success') {
                                    this.data = this.data.filter(dItem => dItem.settled === 0 || dItem.type === 'label');
                                    this.stat = {
                                        ...this.stat,
                                        total_tips: 0,
                                        roi:  0,
                                        profit_pts: 0,
                                        w_rate: 0,
                                        avg_odd: 0,
                                        resetCount: this.stat.resetCount + 1
                                    };

                                    this.real_stat = {                                        
                                        total_tips: 0,
                                        roi:  0,
                                        profit_pts: 0,
                                        w_rate: 0,
                                        avg_odd: 0
                                    };
                                }
                            });
                        }
                    })
            },
            FollowStrategy(_id) {
                var index = this.strategies.findIndex(x => x._id === _id);
                let strategy = this.strategies[index];
                this.toggleFollowStrategy({
                    id: strategy._id
                }).then(({data, status}) => {
                    this.strategies[index].followerCount = data.followers.length;
                    this.strategies[index].followers = data.followers;
                    this.refreshKey ++;
                });
            },
            handleStrategyExcludeStats(status, _id) {
                var index = this.strategies.findIndex(x => x._id === _id);
                
                
                this.strategyExcludeStats({
                    id: _id,
                    status: status
                }).then(({status}) => {
                    this.strategies[index].exclude_stats = !this.strategies[index].exclude_stats;
                    this.refreshKey_strategy ++;
                });
            },
            handleStrategySwitch(status, _id) {
                var index = this.strategies.findIndex(x => x._id === _id);
                
                
                this.strategySwitch({
                    id: _id,
                    status: !status
                }).then(({status}) => {
                    this.strategies[index].hide = !this.strategies[index].hide;
                    this.refreshKey_strategy ++;
                });
            },
            handleStrategyBetfairSwitch(status, _id) {
                this.strategyBetfairSwitch({
                    id: _id,
                    status: status
                }).then(({status}) => {
                    console.log(status)
                });
            },
            handleTelegramSwitch(status, _id) {
                this.strategyTelegramSwitch({
                    id: _id,
                    status: status
                }).then(({status}) => {
                    console.log(status)
                });
            },
            handleDetailClick(_id) {
                // const data = this.strategies[index];
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStat',
                    params: {
                        id: _id,
                        userId: this.paramId
                    }
                });
                window.open(routeData.href, '_blank');
            },
            handleFinancialClick(_id) {
                // const data = this.strategies[index];
                let routeData = this.$router.resolve({
                    name: 'UserStrategyFinancial',
                    params: {
                        id: _id,
                        userId: this.paramId
                    }
                });
                window.open(routeData.href, '_blank');
            },
             handleStatsClick(_id) {
                // const data = this.strategies[index];
                
                console.log('handle user id', this.paramId)
                let routeData = this.$router.resolve({
                    name: 'UserStrategyStats',
                    params: {
                        id: _id,
                        userId: this.paramId
                    }
                });
                window.open(routeData.href, '_blank');
            },
            handleEditClick(_id) {
                var index = this.strategies.findIndex(x => x._id === _id);
                let strategy = this.strategies[index];

                this.strategyId = strategy._id;
                this.edit_name = strategy.name;
                this.edit_description = strategy.description;
                this.$refs['edit_strategy'].show()
                
            },
            handleStrategyExcludeUsers(_id) {
                var index = this.strategies.findIndex(x => x._id === _id);
                let strategy = this.strategies[index];

                this.user_exclude_strategyId = strategy._id;
                this.user_exclude_strategyName = strategy.name;

                this.membership_setting = [];
                if (strategy.membership_setting) {
                    var membership_setting = {}
                    strategy.membership_setting.forEach((row) => {
                        membership_setting[row.name.toString()] = !row.value
                    })
                    
                    var keys = Object.keys(membership_setting)
                    
                    this.membership_id_list.forEach((membership_id) => {
                        if (keys.includes( membership_id.toString() )) {
                            this.membership_setting.push({'name': membership_id, 'value': membership_setting[membership_id.toString()]})
                        }
                        else {
                            this.membership_setting.push({'name': membership_id, 'value': true})
                        }
                    })
                }
                else {
                    this.membership_id_list.forEach((membership_id) => {                  
                        this.membership_setting.push({'name': membership_id, 'value': true})                  
                    })
                }

                this.$refs['exclude_users'].show()


                // membership_setting: [],
                // user_exclude_strategyName: ""
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault();

                this.editStrategy({_id: this.strategyId, name: this.edit_name, description: this.edit_description}).then((data) => {
                    var index = this.strategies.findIndex(x => x._id === this.strategyId);
                    this.strategies[index].name = this.edit_name;
                    this.strategies[index].description = this.edit_description;
                 
                }).finally(() => {
                    // Hide the modal manually
                    this.$nextTick(() => {
                        this.$refs['edit_strategy'].hide();
                    })
                });
            },
            handleCancel(bvModalEvt) {
            },
            handleOk_excludeUsers(bvModalEvt) {
                bvModalEvt.preventDefault();

                let membership_setting = [];               

                this.membership_setting.forEach( item => {
                    
                    let new_value;
                    if (item.value == true)
                        new_value = false;
                    else
                        new_value = true;

                    let new_item = {
                        ...item,
                        value: new_value
                    };
                    
                    membership_setting.push(new_item);
                });

                let exclude_users = "";                            
                exclude_users = membership_setting.filter( level_item => level_item.value == true );
                exclude_users = exclude_users.map(({ name }) => name);
                if ( exclude_users.length > 0 ) {
                    exclude_users = " (" + exclude_users.join(", ") + ")";
                }                            

                this.strategyExcludeUsers({_id: this.user_exclude_strategyId, membership_setting: membership_setting}).then((data) => {
                    var index = this.strategies.findIndex(x => x._id === this.user_exclude_strategyId);
                    
                    this.strategies[index].membership_setting = membership_setting;
                    this.strategies[index].exclude_users = exclude_users;
                 
                }).finally(() => {
                    // Hide the modal manually
                    this.$nextTick(() => {
                        this.$refs['exclude_users'].hide();
                    })
                });                
                
            },
            handleCancel_excludeUsers(bvModalEvt) {
            },
            handleDeleteEventsClick(_id) {
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteEventsByStrategy({strategy: _id}).then((data) => {
                                var index = this.strategies.findIndex(x => x._id === _id);
                                this.strategies[index].total_tips = 0;
                                this.strategies[index].roi = 0;
                                this.strategies[index].profit_pts = 0;
                                this.strategies[index].w_rate = 0;
                                
                            }).finally(() => {
                                swal.fire("Success!", "Deleted Tips succesfully", "success");
                            });
                        }
                    });
            },
            async handleDeleteClick(_id) {
                try {
                    console.log('delete strategies')
                    
                    Swal
                    .fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteStrategy({id: _id}).then((res) => {
                                var index = this.strategies.findIndex(x => x._id === _id);
                                this.strategies.splice(index, 1);
                                displaySuccess(res);
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
                    
                    
                } catch(err) {
                    console.log(err);
                }
            },
            handleCashOut(tip_id, cashout_type, auto_cashout) {
                let idx = this.data.findIndex(item => item._id === tip_id);
                let cashout_item = {
                    ...this.data[idx],
                    cashout_type: cashout_type,
                    auto_cashout: auto_cashout,
                    first_input: true
                }
                this.cashoutQueue.push(cashout_item);
            },
            check_autoTipCashout(dItem, fIndex) {
                if (dItem.ref_profitPts) {
                    var val = parseFloat(dItem.ref_profitPts);
                    if (dItem.currentPointProfit >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_profitPro) {
                    var val = parseFloat(dItem.ref_profitPro);
                    var profitPro = 100 * (dItem.currentPointProfit / dItem.stake)
                    if (profitPro >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_stoploss) {
                    var val = -1 * parseFloat(dItem.ref_stoploss);
                    var profitPro = 100 * (dItem.currentPointProfit / dItem.stake) 
                    if (profitPro <= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_nextodd) {
                    var val = parseFloat(dItem.ref_nextodd);
                    
                    if (dItem.currentOdd && dItem.currentOdd >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_nextodd_lower) {
                    var val = parseFloat(dItem.ref_nextodd_lower);
                    
                    if (dItem.currentOdd && dItem.currentOdd <= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_time) {
                    var val = parseFloat(dItem.ref_time);                    
                    if (dItem.current_minute && dItem.current_minute >= val) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }

                if (dItem.ref_score) {
                    if (dItem.ref_score == 'None')
                        return false
                    var old_score = dItem.ref_momnent_score;
                    var current_score = dItem.currentScore;
                    if (old_score == current_score)
                        return false;

                    var old_homeGoals = parseInt(old_score.split(':')[0].trim());
                    var old_awayGoals = parseInt(old_score.split(':')[1].trim());
                    var current_homeGoals = parseInt(current_score.split(':')[0].trim());
                    var current_awayGoals = parseInt(current_score.split(':')[1].trim());
                    var current_goals = current_homeGoals + current_awayGoals;

                    if (dItem.ref_score == 'Home' && current_homeGoals > old_homeGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Draw' && current_homeGoals === current_awayGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Away' && current_awayGoals > old_awayGoals) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'BTS' && current_homeGoals > 0 && current_awayGoals > 0) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }

                    if (dItem.ref_score == 'Over 0.5' && current_goals > 0) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 1.5' && current_goals > 1) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 2.5' && current_goals > 2) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 3.5' && current_goals > 3) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                    if (dItem.ref_score == 'Over 4.5' && current_goals > 4) {
                        this.handleCashOut(dItem._id, 0, 'tip');
                        return true;
                    }
                }
                // this.data[fIndex].ref_numOfAttempt = parseInt(this.data[fIndex].ref_numOfAttempt) - 1;

            },
            check_autoCoverCashout(dItem, fIndex) {
                if (dItem.cover_ref_profitPts) {
                    var val = parseFloat(dItem.cover_ref_profitPts);
                    if (dItem.cover_currentPointProfit >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_profitPro) {
                    var val = parseFloat(dItem.cover_ref_profitPro);
                    var profitPro = 100 * (dItem.cover_currentPointProfit / dItem.cover_stake)
                    if (profitPro >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_stoploss) {
                    var val = -1 * parseFloat(dItem.cover_ref_stoploss);
                    var profitPro = 100 * (dItem.cover_currentPointProfit / dItem.cover_stake) 
                    if (profitPro <= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_nextodd) {
                    var val = parseFloat(dItem.cover_ref_nextodd);
                    
                    if (dItem.cover_currentOdd && dItem.cover_currentOdd >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_nextodd_lower) {
                    var val = parseFloat(dItem.cover_ref_nextodd_lower);
                    
                    if (dItem.cover_currentOdd && dItem.cover_currentOdd <= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_time) {
                    var val = parseFloat(dItem.cover_ref_time);                    
                    if (dItem.current_minute && dItem.current_minute >= val) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }

                if (dItem.cover_ref_score) {
                    if (dItem.cover_ref_score == 'None')
                        return false
                    var old_score = dItem.ref_momnent_score;
                    var current_score = dItem.currentScore;
                    if (old_score == current_score)
                        return false;

                    var old_homeGoals = parseInt(old_score.split(':')[0].trim());
                    var old_awayGoals = parseInt(old_score.split(':')[1].trim());
                    var current_homeGoals = parseInt(current_score.split(':')[0].trim());
                    var current_awayGoals = parseInt(current_score.split(':')[1].trim());
                    var current_goals = current_homeGoals + current_awayGoals;

                    if (dItem.cover_ref_score == 'Home' && current_homeGoals > old_homeGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Draw' && current_homeGoals === current_awayGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Away' && current_awayGoals > old_awayGoals) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'BTS' && current_homeGoals > 0 && current_awayGoals > 0) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }

                    if (dItem.cover_ref_score == 'Over 0.5' && current_goals > 0) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 1.5' && current_goals > 1) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 2.5' && current_goals > 2) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 3.5' && current_goals > 3) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                    if (dItem.cover_ref_score == 'Over 4.5' && current_goals > 4) {
                        this.handleCashOut(dItem._id, 1, 'cover');
                        return true;
                    }
                }
                // this.data[fIndex].cover_ref_numOfAttempt = parseInt(this.data[fIndex].cover_ref_numOfAttempt) - 1;

            },
            updateCashOut() {
                this.getMyPendingFeeds().then(({data}) => {                    
                    data.forEach((dItem) => {
                        let fIndex = this.data.findIndex(item => item._id === dItem._id);
                        
                        if(fIndex > -1) {
                            /** update fixture */
                            var currentStatus = '';
                            var currentScore = '';
                            var currentPointProfit = '';
                            var currentOdd = '';
                            var currentOdd_suspended = false;
                            var cashOut = '';

                            var cover_currentPointProfit = '';
                            var cover_currentOdd = '';
                            var cover_currentOdd_suspended = false;
                            var cover_cashOut = '';
                            var cover_cashOut_flag = false;

                            var current_minute = null;

                            if (dItem.cover_predictionType && dItem.cover_stake && dItem.cover_odd)
                                cover_cashOut_flag = true;

                            if (dItem.settled === 0) {
                                const fixture = dItem.fixture;
                                const status = fixture[0].time.status;
                                const time = fixture[0].time;
                                const scores = fixture[0].scores;
                                /** get current status */
                                currentStatus = status;
                                if (status === 'LIVE' || status === 'HT') {
                                    let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                                    let second = time.second ? time.second : '00';
                                    let added_time = time.added_time ? `+${time.added_time}\'` : '';
                                    currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                                    current_minute = time.minute;
                                }
                                /** current score */
                                currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                                /** get current odd */
                                let odds = [];
                                const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                                const ht_market_ids = [37, 31379, 975903, 976226, 31359];
                                const drawnobet_market_ids = [28082,137918013,136696391];

                                if (status === 'LIVE' || status == 'HT') {
                                    odds = fixture[0].inplayOdds.data;
                                } else if (status === 'NS') {
                                    odds = fixture[0].flatOdds.data;
                                }
                                odds
                                    .filter(item => item.bookmaker_id === 2)
                                    .forEach(oItem => {
                                        let suffix = '';
                                        if (ft_market_ids.includes(oItem.market_id))
                                            suffix = 'FT';
                                        else if (ht_market_ids.includes(oItem.market_id))
                                            suffix = 'HT';
                                        else if(oItem.market_id == 63)
                                            suffix = 'Double chance';
                                        else if (drawnobet_market_ids.includes(oItem.market_id))
                                            suffix = 'Draw no bet';
                                        (oItem.odds || oItem.values).forEach((item, index) => {
                                            let label;
                                            if (oItem.market_id == 63) {
                                                if (index == 0)
                                                    label = '1X';
                                                else if (index == 1)
                                                    label = 'X2';
                                                else
                                                    label = '12';
                                            }
                                            else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                                if (index == 0)
                                                    label = 'Home';
                                                else if (index == 1)
                                                    label = 'Away';
                                            }
                                            else {
                                                if (item.label)
                                                    label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                                else if (item.team)
                                                    label = item.team;
                                                else if (item.info) {
                                                    label = item.info;
                                                }
                                                if (label === 'Yes')
                                                    label = 'BTS';
                                                else if (label === 'No')
                                                    label = 'No BTS';
                                                if (label === '1')
                                                    label = "Home";
                                                else if (label === '2')
                                                    label = 'Away';
                                                else if (label === 'X')
                                                    label = 'Draw';
                                            }
                                            

                                            if (`${label} - ${suffix}`.trim() === dItem.predictionType) {
                                                currentOdd = parseFloat(item.value);
                                                if (oItem.suspended !== null)
                                                    currentOdd_suspended = oItem.suspended;
                                                else
                                                    currentOdd_suspended = item.suspend;
                                                
                                            }
                                            if (`${label} - ${suffix}`.trim() === dItem.cover_predictionType){
                                                cover_currentOdd = parseFloat(item.value);
                                                if (oItem.suspended !== null)
                                                    cover_currentOdd_suspended = oItem.suspended;
                                                else
                                                    cover_currentOdd_suspended = item.suspend;
                                            }

                                        });
                                    });
                                if (currentOdd) {
                                    
                                    /** cash out */
                                    cashOut = parseFloat((dItem.odd * dItem.stake / currentOdd).toFixed(2));
                                    /** current point profit */
                                    currentPointProfit = parseFloat((cashOut - dItem.stake).toFixed(2));
                                }
                                if (cover_currentOdd) {
                                    
                                    /** cash out */
                                    cover_cashOut = parseFloat((dItem.cover_odd * dItem.cover_stake / cover_currentOdd).toFixed(2));
                                    /** current point profit */
                                    cover_currentPointProfit = parseFloat((cover_cashOut - dItem.cover_stake).toFixed(2));
                                }
                            }

                            // this.data[fIndex] = {
                            //     ...this.data[fIndex],
                            //     dItem
                            // }

                            let new_item = {
                                ...this.data[fIndex],
                                ...dItem
                            }
                           
                            new_item.currentStatus = currentStatus
                            new_item.currentScore = currentScore
                            new_item.currentPointProfit = currentPointProfit
                            new_item.currentOdd = currentOdd
                            new_item.cashOut = cashOut

                            new_item.currentOdd_suspended = currentOdd_suspended
                            new_item.cover_currentOdd_suspended = cover_currentOdd_suspended

                            new_item.cover_cashOut_flag = cover_cashOut_flag
                            new_item.cover_currentPointProfit = cover_currentPointProfit
                            new_item.cover_currentOdd = cover_currentOdd
                            new_item.cover_cashOut = cover_cashOut
                            new_item.current_minute = current_minute

                            let dateTime = convertUTCToLocal(dItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                            new_item['dateTime'] = defaultFormat(dateTime);
                            
                            this.data.splice(fIndex, 1);
                            this.data.splice(fIndex, 0, new_item);
                           
                            if (this.userId == dItem.userId){
                                if (!dItem.cashout && dItem.ref_numOfAttempt && dItem.ref_numOfAttempt > 0 && currentPointProfit !== '' && currentOdd && !currentOdd_suspended){
                                    let selections = this.cashoutQueue.filter(function(runner) {
                                        return runner._id == new_item._id && runner.auto_cashout == 'tip';
                                    });
                                    if (selections.length == 0){
                                        console.log('auto-tip cash out')
                                        this.check_autoTipCashout(new_item, fIndex);
                                    }
                                }
                                if (!dItem.cover_cashout && dItem.cover_ref_numOfAttempt && dItem.cover_ref_numOfAttempt > 0 && cover_currentPointProfit !== '' && cover_currentOdd && !cover_currentOdd_suspended) {
                                    let selections = this.cashoutQueue.filter(function(runner) {
                                        return runner._id == new_item._id && runner.auto_cashout == 'cover';
                                    });
                                    if (selections.length == 0){
                                        console.log('auto-cover cash out')
                                        this.check_autoCoverCashout(new_item, fIndex);
                                    }
                                }
                            }
                        }
                    });                   

                    this.checkCashOut();
                });
        
            },
            checkCashOut() {
               
                for (var cIndex=0; cIndex < this.cashoutQueue.length; cIndex++) {
                    var cItem = this.cashoutQueue[cIndex];

                    if ((cItem.auto_cashout == 'tip' || cItem.auto_cashout == 'cover') && cItem.first_input ) {
                        this.cashoutQueue[cIndex].first_input = false;
                        console.log('skip one')
                        continue;
                    }

                
                    let fIndex = this.data.findIndex(item => item._id === cItem._id);
                    
                    if(fIndex > -1) {
                        
                        // if (_data[fIndex].openComments === false) {
                        let just = this.data[fIndex];
                        
                        if ((cItem.cashout_type === 0 && cItem.currentOdd === just.currentOdd) || (cItem.cashout_type === 1 && cItem.cover_currentOdd === just.cover_currentOdd) && cItem.currentScore === just.currentScore)
                            
                        {
                            console.log('=== infinite loop ')
                            try {
                                this.cashOut(cItem).then((res) => {
                                    let temp = {
                                        ...this.data[fIndex],
                                        ...res.data
                                    }
                                   
                                    let dateTime = convertUTCToLocal(temp.dateTime, (new Date()).getTimezoneOffset() / 60);
                                    temp['dateTime'] = defaultFormat(dateTime);
                                    
                                    this.data.splice(fIndex, 1);
                                    this.data.unshift(temp);
                                    displaySuccess(res);
                                });
                            } catch(err) {
                                displayError(err);
                            } finally {                                
                                this.cashoutQueue.splice(cIndex, 1);
                            }
                        } else {
                            if(this.cashoutQueue.length > 0) {
                                if (cItem.auto_cashout == 'tip' || cItem.auto_cashout =='cover') {
                                    let cashout_ref = {};
                                    let cover_cashout_ref = {};

                                    if (cItem.auto_cashout == 'tip') {
                                        cashout_ref = {
                                            'ref_numOfAttempt': parseInt(cItem.ref_numOfAttempt) - 1
                                        }
                                        this.data[fIndex].ref_numOfAttempt = parseInt(cItem.ref_numOfAttempt) - 1
                                    }
                                    else {
                                        cover_cashout_ref = {
                                            'cover_ref_numOfAttempt': parseInt(cItem.cover_ref_numOfAttempt) - 1
                                        }
                                        this.data[fIndex].cover_ref_numOfAttempt = parseInt(cItem.cover_ref_numOfAttempt) - 1
                                    }

                                    this.postCashoutRef({_id: cItem._id, cashout_ref: cashout_ref, cover_cashout_ref: cover_cashout_ref}).then((data) => {
                                        console.log('=====     attempt num reduced   =====')
                                        
                                    }).finally(() => {
                                        this.cashoutQueue.splice(cIndex, 1);
                                        displayError({message: "Posting failed due to change of odds or score."});
                                    });
                                }
                                else {
                                    this.cashoutQueue.splice(cIndex, 1);
                                    displayError({message: "Posting failed due to change of odds or score."});
                                }
                            }
                        }
                        
                        break;
                    }
                    
                }
            },
            makeFeed(fItem) {
                let comments = [];
                
                let fixture = fItem.fixture[0];
                if (fixture.stage_has_standings)
                    fItem['eventName'] = `${fixture.localTeamName} (${fixture.home_rank}) v ${fixture.visitorTeamName} (${fixture.away_rank})`;
                else
                    fItem['eventName'] = `${fixture.localTeamName} v ${fixture.visitorTeamName}`;
                let startingAt = convertUTCToLocal(fixture.time.starting_at.date_time);
                fItem['startingAt'] = startingAt.toLocaleDateString() + ' ' + startingAt.toLocaleTimeString();
                fItem['status'] = fItem.status;
                let dateTime = convertUTCToLocal(fItem.dateTime, (new Date()).getTimezoneOffset() / 60);
                fItem['dateTime'] = defaultFormat(dateTime);
                const {scores} = fixture;
                if(['FT', 'AET', 'FT_PEN'].includes(fixture.time.status)){
                    if (scores.ft_score) 
                        fItem['result'] = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                    else
                        fItem['result'] = `${scores.localteam_score}-${scores.visitorteam_score} FT(${scores.ht_score} HT)`;
                }
                fItem['replyTo'] = [];

                const {selected} = this.$route.params;
                var openComments = false;
                fItem.comments.forEach((cItem) => {
                    var unread = false;
                    if (this.notifications.length > 0) {
                        unread = this.notifications.find(nItem => nItem.commentId === cItem._id && !nItem.readAt)
                    }
                    
                    comments.push({
                        ...cItem,
                        dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                        userName: cItem.user[0].alias,
                        userAvatar: `${cItem.user[0].avatar}`,
                        unread: unread
                    });
                    if (cItem._id == selected){
                        openComments = true;
                    }
                });                
                
                fItem = {
                    ...fItem  ,
                    userName: fItem.user[0].alias,
                    userAvatar: `${fItem.user[0].avatar}`,
                    comments,
                    followTip: (fItem.follow || []).includes(parseInt(this.loggedInUser.user_id)),
                    likeTip: (fItem.like || []).includes(parseInt(this.loggedInUser.user_id)),
                    followUserCount: (fItem.followingUsers || []).length,
                    openComments: openComments
                };

                var currentStatus = '';
                var currentScore = '';
                var currentPointProfit = '';
                var currentOdd = '';
                var currentOdd_suspended = false;
                var cashOut = '';

                var cover_currentPointProfit = '';
                var cover_currentOdd = '';
                var cover_currentOdd_suspended = false;
                var cover_cashOut = '';
                var cover_cashOut_flag = false;
                if (fItem.cover_predictionType && fItem.cover_stake && fItem.cover_odd)
                    cover_cashOut_flag = true;

                const drawnobet_market_ids = [28082,137918013,136696391];

                if (fItem.cashout || fItem.settled !== 0) {
                    const scores = fItem.fixture[0].scores;
                    if (scores.ft_score && scores.ht_score)
                        currentStatus = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                    else if (scores.ht_score)
                        currentStatus = `${scores.ht_score} HT`;
                    else
                        currentStatus = 'NS';
                } else if (fItem.settled === 0) {
                    const fixture = fItem.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [];
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';

                            (oItem.odds || oItem.values).forEach((item, index) => {
                                let label;
                                if (oItem.market_id == 63) {
                                    if (index == 0)
                                        label = '1X';
                                    else if (index == 1)
                                        label = 'X2';
                                    else
                                        label = '12';
                                }
                                else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                    if (index == 0)
                                        label = 'Home';
                                    else if (index == 1)
                                        label = 'Away';
                                }
                                else {
                                    if (item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if (item.team)
                                        label = item.team;
                                    else if (item.info) {
                                        label = item.info;
                                    }
                                    if (label === 'Yes')
                                        label = 'BTS';
                                    else if (label === 'No')
                                        label = 'No BTS';
                                    if (label === '1')
                                        label = "Home";
                                    else if (label === '2')
                                        label = 'Away';
                                    else if (label === 'X')
                                        label = 'Draw';
                                }
                                
                                if (`${label} - ${suffix}`.trim() === fItem.predictionType){
                                    currentOdd = parseFloat(item.value);                                    
                                    if (oItem.suspended !== null)
                                        currentOdd_suspended = oItem.suspended;
                                    else
                                        currentOdd_suspended = item.suspend;
                                }

                               

                            });
                        });
                    if (currentOdd) {
                        
                        /** cash out */
                        cashOut = parseFloat((fItem.odd * fItem.stake / currentOdd).toFixed(2));
                        /** current point profit */
                        currentPointProfit = parseFloat((cashOut - fItem.stake).toFixed(2));
                    }
                   
                }

                if (fItem.settled === 0 && cover_cashOut_flag) {
                    const fixture = fItem.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [];
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';
                            (oItem.odds || oItem.values).forEach((item, index) => {
                                let label;
                                if (oItem.market_id == 63) {
                                    if (index == 0)
                                        label = '1X';
                                    else if (index == 1)
                                        label = 'X2';
                                    else
                                        label = '12';
                                }
                                else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                    if (index == 0)
                                        label = 'Home';
                                    else if (index == 1)
                                        label = 'Away';
                                }
                                else {
                                    if (item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if (item.team)
                                        label = item.team;
                                    else if (item.info) {
                                        label = item.info;
                                    }
                                    if (label === 'Yes')
                                        label = 'BTS';
                                    else if (label === 'No')
                                        label = 'No BTS';
                                    if (label === '1')
                                        label = "Home";
                                    else if (label === '2')
                                        label = 'Away';
                                    else if (label === 'X')
                                        label = 'Draw';
                                }
                                
                                if (`${label} - ${suffix}`.trim() === fItem.cover_predictionType){
                                    cover_currentOdd = parseFloat(item.value);
                                    
                                    if (oItem.suspended !== null)
                                        cover_currentOdd_suspended = oItem.suspended;
                                    else
                                        cover_currentOdd_suspended = item.suspend;
                                }

                            });
                        });                   
                    if (cover_currentOdd) {
                        
                        /** cash out */
                        cover_cashOut = parseFloat((fItem.cover_odd * fItem.cover_stake / cover_currentOdd).toFixed(2));
                        /** current point profit */
                        cover_currentPointProfit = parseFloat((cover_cashOut - fItem.cover_stake).toFixed(2));
                    }
                }

                fItem = {
                    ...fItem,
                    currentStatus:  currentStatus,
                    currentScore: currentScore,
                    currentPointProfit: currentPointProfit,
                    currentOdd: currentOdd,
                    currentOdd_suspended: currentOdd_suspended,
                    cashOut: cashOut,
                    cover_currentPointProfit: cover_currentPointProfit,
                    cover_currentOdd: cover_currentOdd,
                    cover_currentOdd_suspended: cover_currentOdd_suspended,
                    cover_cashOut: cover_cashOut,
                    cover_cashOut_flag: cover_cashOut_flag,
                    online_refreshKey: this.create_UUID()
                };


                return fItem;
                
            },
            create_UUID(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid
            },
            init() {
                console.log("===============   init function")
                this.runTimer();
                const {id, notifications} = this.$route.params;
                this.paramId = id;
                if(notifications) {
                    this.notifications = notifications.slice();
                    console.log('notifications', this.notifications)
                }
                this.data = [];
                this.getFeedsByUserId({id: parseInt(id)}).then(({data: {feeds, stat, stat1, userIsFollowed}}) => {
                    this.userIsFollowed = userIsFollowed;
                    this.stat = {
                        ...this.stat,
                        userId: parseInt(id),
                        userName: stat.user[0].alias,
                        userAvatar: stat.user[0].avatar,
                        followers: stat.followers,
                        resetCount: stat.resetCount
                    }                   

                    if(stat.totalCount) {
                        this.stat = {
                            ...this.stat,
                            total_tips: stat.totalCount,
                            roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat.profitPTS.toFixed(2),
                            w_rate: stat.settledLose + stat.settledWin ? ((stat.settledWin / (stat.settledLose + stat.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat.settledLose + stat.settledWin ? ((stat.totalOdd / (stat.settledLose + stat.settledWin))).toFixed(2) : 0,
                        };
                    }

                    if(stat1.totalCount) {
                        this.real_stat = {
                            ...this.real_stat,
                            total_tips: stat1.totalCount,
                            roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                            profit_pts: stat1.profitPTS.toFixed(2),
                            w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                            avg_odd: stat1.settledLose + stat1.settledWin ? ((stat1.totalOdd / (stat1.settledLose + stat1.settledWin))).toFixed(2) : 0,
                        };
                    }
                    feeds.sort((a, b) => {
                        return Math.abs(a.settled) - Math.abs(b.settled);
                    });
                    feeds.forEach(fItem => {
                        if (this.loggedInUser.user_id !=0 && fItem.strategyData && fItem.strategyData.hide === true) {
                            
                        }
                        else {
                            this.data.push(this.makeFeed(fItem));
                        }

                        
                    });
                }).finally(() => {
                    this.runTimer(false);
                    /** move scroll to one from notification */
                    const {selected} = this.$route.params;
                    console.log('============   selected   =====', selected)
                    if(selected) {
                        setTimeout(() => {
                            this.$nextTick(() => {
                                var el = document.querySelector(`#id${selected}`);
                                el.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center'
                                });
                            });          
                        }, 500);
                    }
                });
                this.initStrategies();
                this.initStats();
            },
            initStrategies() {
                const {id} = this.$route.params;
                this.getUserStrategies({id: parseInt(id)}).then(({data}) => {
                    this.strategies = [];

                    
                    data.forEach(dItem => {
                        let stat = dItem.stat;
                        let actions = [
                            
                            {
                                type: 'button',
                                label: this.$t('Stats'),
                                funcAction: this.handleStatsClick
                            },{
                                type: 'button',
                                label: this.$t('Details'),
                                funcAction: this.handleDetailClick
                            }, {
                                type: 'button',
                                label: this.$t('Financial'),
                                funcAction: this.handleFinancialClick
                            }, {
                                type: 'button',
                                label: this.$t('Delete'),
                                disabled: dItem.notTracked,
                                color: 'danger',
                                funcAction: this.handleDeleteClick
                            }, {
                                type: 'button',
                                label: this.$t('Edit'),
                                color: 'danger',
                                disabled: dItem.notTracked,
                                funcAction: this.handleEditClick
                            }, {
                                type: 'button',
                                label: this.$t('Delete Events'),
                                color: 'danger',
                                funcAction: this.handleDeleteEventsClick
                            },

                            
                            
                        ];
                        
                        if(`${id}` !== `${this.loggedInUser.user_id}`)
                            actions = actions.slice(0, 3);
                        else if(`${id}` != 0 )
                            actions = actions.slice(0, 4);

                        // if(`${id}` == `${this.loggedInUser.user_id}` || `${id}` == 0) {
                        if(parseInt(this.loggedInUser.user_id) === 0 && `${id}` == 0) {
                            actions.push({
                                type: 'switch_stats',
                                label: this.$t('Stats'),
                                funcAction: this.handleStrategySwitch
                            });

                            actions.push({
                                type: 'exclude_stats',
                                funcAction: this.handleStrategyExcludeStats
                            });
                        }
                            

                        if (parseInt(this.loggedInUser.user_id) === 0) {
                            // actions.push({
                            //     type: 'button',
                            //     label: this.$t('Financial'),
                            //     funcAction: this.handleFinancialClick
                            // });
                            actions.push({
                                type: 'switch_betfair',
                                funcAction: this.handleStrategyBetfairSwitch
                            });
                        }

                        if (parseInt(this.loggedInUser.user_id) === 0 && id == 0) {
                            // actions.push({
                            //     type: 'button',
                            //     label: this.$t('Financial'),
                            //     funcAction: this.handleFinancialClick
                            // });
                            actions.push({
                                type: 'telegram',
                                funcAction: this.handleTelegramSwitch
                            });

                            actions.push(                                
                                {
                                    type: 'exclude_users',
                                    label: this.$t('Subscr ID'),
                                    color: 'danger',
                                    funcAction: this.handleStrategyExcludeUsers
                                }
                            );


                        }

                        if (parseInt(this.loggedInUser.user_id) != 0 && dItem.hide){
                            console.log('=== false ===')
                        }
                        else{
                            let strategy_name = dItem.name;
                            if (strategy_name == "not tracked event")
                                strategy_name = this.$t("no strategy tips")

                            let exclude_users = "";
                            if (dItem.membership_setting) {
                                exclude_users = dItem.membership_setting.filter( level_item => level_item.value == true );
                                exclude_users = exclude_users.map(({ name }) => name);
                                if ( exclude_users.length > 0 ) {
                                    exclude_users = " (" + exclude_users.join(", ") + ")";
                                }                                
                            };
                            let exclude_stats = false;
                            if (dItem.exclude_stats) {
                                exclude_stats = dItem.exclude_stats;
                            };

                            this.strategies.push(
                                {
                                    ...dItem,
                                    total_tips: stat.totalCount || 0,
                                    avg_odd: stat.totalCount ? parseFloat((stat.totalOdd / (stat.settledWin + stat.settledLose))).toFixed(2) : 0,
                                    pending_tips: stat.totalCount ? stat.totalCount - stat.settledWin - stat.settledLose : 0,
                                    roi:  stat.stakeTotal ? parseFloat((stat.profitPTS / stat.stakeTotal * 100).toFixed(2)) : 0,
                                    profit_pts: stat.profitPTS ? parseFloat(stat.profitPTS.toFixed(2)) : 0,
                                    w_rate: (stat.settledWin + stat.settledLose) ? parseFloat(((stat.settledWin / (stat.settledWin + stat.settledLose)) * 100).toFixed(2)) : 0,
                                    followerCount: (dItem.followers || []).length,
                                    onFollow: this.FollowStrategy,
                                    actions,
                                    name: strategy_name,
                                    exclude_users: exclude_users,
                                    exclude_stats: exclude_stats
                                }
                            )
                        }
                    });

                    console.log("======this.strategies======", this.strategies);
                });
            },
            initStats() {
                const {id} = this.$route.params;
                this.getStatsByUserId({id: id, strategyId: null}).then(({data}) => {
                    this.stats1 = [];
                    this.stats2 = [];
                    
                    for (var i = 0; i < data.data1.length; i++) {
                        var league = data.data1[i];
                        var item = {};
                        
                        if (!league['league_name'])
                            continue
                        // item['league_id'] = league['league_id']
                        
                        item['League'] = league['league_name'];
                        item['Country'] = league['country_name'];
                        
                        if (league['total_matches'] == 0)
                            continue

                        item['Matches'] = parseFloat(league['total_matches']);
                        item['Matches_ids'] = league['total_matches_ids'];                        
                        item['home'] = parseFloat(league['home_win_percent']);
                        item['draw'] = parseFloat(league['draw_win_percent']);
                        item['away'] = parseFloat(league['away_win_percent']);
                        item['1st Half'] = parseFloat(league['avg_firsthalf_goals_percent']);
                        item['2nd Half'] = parseFloat(league['avg_secondhalf_goals_percent']);
                        item['total'] = parseFloat(league['avg_total_goals_percent']);
                        item['0.5 FH'] = parseFloat(league['first_05_percent']);
                        item['1.5 FH'] = parseFloat(league['first_15_percent']);
                        item['2.5 FH'] = parseFloat(league['first_25_percent']);
                        item['0.5'] = parseFloat(league['full_05_percent']);
                        item['1.5'] = parseFloat(league['full_15_percent']);
                        item['2.5'] = parseFloat(league['full_25_percent']);
                        item['3.5'] = parseFloat(league['full_35_percent']);
                        item['4.5'] = parseFloat(league['full_45_percent']);
                        item['bts'] = parseFloat(league['bts_percent']);
                        item['0~15'] = parseFloat(league['goal_bands_15_percent']);
                        item['16~30'] = parseFloat(league['goal_bands_30_percent']);
                        item['31~45'] = parseFloat(league['goal_bands_45_percent']);
                        item['46~60'] = parseFloat(league['goal_bands_60_percent']);
                        item['61~75'] = parseFloat(league['goal_bands_75_percent']);
                        item['76~90'] = parseFloat(league['goal_bands_90_percent']);
                        item['Home'] = parseFloat(league['fts_h_percent']);
                        item['H Win'] = parseFloat(league['fts_hw_percent']);
                        item['Away'] = parseFloat(league['fts_a_percent']);
                        item['A Win'] = parseFloat(league['fts_aw_percent']);

                        item['home_pt_percent'] = parseFloat(league['home_pt_percent']);
                        item['away_pt_percent'] = parseFloat(league['away_pt_percent']);
                        item['draw_pt_percent'] = parseFloat(league['draw_pt_percent']);
                        item['sh_05_percent'] = parseFloat(league['sh_05_percent']);
                        item['sh_15_percent'] = parseFloat(league['sh_15_percent']);
                        item['sh_25_percent'] = parseFloat(league['sh_25_percent']);
                        item['ht_firstGoal_min_avg'] = parseFloat(league['ht_firstGoal_min_avg']);
                        item['sh_firstGoal_min_avg'] = parseFloat(league['sh_firstGoal_min_avg']);
                        this.stats1.push(item);
                        
                    }
                    for (var i = 0; i < data.data2.length; i++) {
                        var league = data.data2[i];
                        var item = {};
                        
                        if (!league['league_name'])
                            continue
                        // item['league_id'] = league['league_id']
                        
                        item['League'] = league['league_name'];
                        item['Country'] = league['country_name'];
                        
                        if (league['total_matches'] == 0)
                            continue
                        item['Matches'] = parseFloat(league['total_matches']);
                        item['Matches_ids'] = league['total_matches_ids'];
                        item['home'] = parseFloat(league['home_win_percent']);
                        item['draw'] = parseFloat(league['draw_win_percent']);
                        item['away'] = parseFloat(league['away_win_percent']);
                        item['1st Half'] = parseFloat(league['avg_firsthalf_goals_percent']);
                        item['2nd Half'] = parseFloat(league['avg_secondhalf_goals_percent']);
                        item['total'] = parseFloat(league['avg_total_goals_percent']);
                        item['0.5 FH'] = parseFloat(league['first_05_percent']);
                        item['1.5 FH'] = parseFloat(league['first_15_percent']);
                        item['2.5 FH'] = parseFloat(league['first_25_percent']);
                        item['0.5'] = parseFloat(league['full_05_percent']);
                        item['1.5'] = parseFloat(league['full_15_percent']);
                        item['2.5'] = parseFloat(league['full_25_percent']);
                        item['3.5'] = parseFloat(league['full_35_percent']);
                        item['4.5'] = parseFloat(league['full_45_percent']);
                        item['bts'] = parseFloat(league['bts_percent']);
                        item['0~15'] = parseFloat(league['goal_bands_15_percent']);
                        item['16~30'] = parseFloat(league['goal_bands_30_percent']);
                        item['31~45'] = parseFloat(league['goal_bands_45_percent']);
                        item['46~60'] = parseFloat(league['goal_bands_60_percent']);
                        item['61~75'] = parseFloat(league['goal_bands_75_percent']);
                        item['76~90'] = parseFloat(league['goal_bands_90_percent']);
                        item['Home'] = parseFloat(league['fts_h_percent']);
                        item['H Win'] = parseFloat(league['fts_hw_percent']);
                        item['Away'] = parseFloat(league['fts_a_percent']);
                        item['A Win'] = parseFloat(league['fts_aw_percent']);

                        item['home_pt_percent'] = parseFloat(league['home_pt_percent']);
                        item['away_pt_percent'] = parseFloat(league['away_pt_percent']);
                        item['draw_pt_percent'] = parseFloat(league['draw_pt_percent']);
                        item['sh_05_percent'] = parseFloat(league['sh_05_percent']);
                        item['sh_15_percent'] = parseFloat(league['sh_15_percent']);
                        item['sh_25_percent'] = parseFloat(league['sh_25_percent']);
                        item['ht_firstGoal_min_avg'] = parseFloat(league['ht_firstGoal_min_avg']);
                        item['sh_firstGoal_min_avg'] = parseFloat(league['sh_firstGoal_min_avg']);
                        this.stats2.push(item);
                        
                    }
                });
            },
            async handleCreate() {
                try {
                    const res = await this.createStrategy({
                        name: this.name,
                        description: this.description
                    });
                    displaySuccess(res);
                    this.name = '';
                    this.description = '';
                    this.initStrategies();
                } catch(err) {
                    console.log(err);
                }
            }
        },
        watch: {
            '$route.params': {
                deep: true,
                immediate: true,
                handler(val) {
                    if(!this.loading)
                        this.init();
                }
            }
        },
        mounted() {
            let user_id = localStorage.getItem('user_id');
            this.userId = parseInt(user_id);

            const {id, notifications} = this.$route.params;

            if ( user_id == 0 && id == 0 ) {
                 this.membership_ids().then((data) => {                    
                    this.membership_id_list = data.data;
                    this.membership_id_list.sort(function(a, b){return a-b});
                 
                }).finally(() => {
                });
            }

            this.sockets.subscribe('new-comment', ({tipId, comments}) => {
                let index = this.data.findIndex(dItem => dItem._id === tipId);
                if(index > -1) {
                    this.data[index].comments = comments.map(cItem => ({
                        ...cItem,
                        dateTime: defaultFormat(convertUTCToLocal(cItem.dateTime, (new Date()).getTimezoneOffset() / 60)),
                        userName: cItem.user[0].alias,
                        userAvatar: `${cItem.user[0].avatar}`
                    }));
                }

                
            });
            this.sockets.subscribe('newFeed', (feed) => {

                if ( id == feed.userId) {
                    if (this.loggedInUser.user_id !=0 && feed.strategyData && feed.strategyData.hide === true) {
                            
                    }
                    else {
                        const temp = this.makeFeed(feed);
                        this.data.unshift(temp);
                        this.stat.total_tips = this.stat.total_tips + 1;
                        let fIndex = this.strategies.findIndex(item => item.userId === feed.userId);
                        if(fIndex > -1)
                            this.strategies[fIndex].total_tips = this.strategies[fIndex].total_tips + 1;
                    }
                    
                }
                
            });
            this.sockets.subscribe('tip-settled', ({tip, stat, stat1}) => {

                if ( id == tip.userId) {
                    // if (this.loggedInUser.user_id !=0) {
                    //     this.stat = {
                    //         ...this.stat,
                    //         total_tips: stat1.totalCount,
                    //         roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                    //         profit_pts: stat1.profitPTS.toFixed(2),
                    //         w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                    //     };
                    // }
                    // else {
                    //     this.stat = {
                    //         ...this.stat,
                    //         total_tips: stat.totalCount,
                    //         roi:  stat.stakeTotal ? (stat.profitPTS / stat.stakeTotal * 100).toFixed(2) : 0,
                    //         profit_pts: stat.profitPTS.toFixed(2),
                    //         w_rate: stat.settledLose + stat.settledWin ? ((stat.settledWin / (stat.settledLose + stat.settledWin)) * 100).toFixed(2) : 0,
                    //     };
                    //     this.real_stat = {
                    //         ...this.real_stat,
                    //         total_tips: stat1.totalCount,
                    //         roi:  stat1.stakeTotal ? (stat1.profitPTS / stat1.stakeTotal * 100).toFixed(2) : 0,
                    //         profit_pts: stat1.profitPTS.toFixed(2),
                    //         w_rate: stat1.settledLose + stat1.settledWin ? ((stat1.settledWin / (stat1.settledLose + stat1.settledWin)) * 100).toFixed(2) : 0,
                    //     }
                    // }
                    
                    // console.log("-----------------   tip-settled", tip)
                    // let fIndex = this.data.findIndex(item => item._id === tip._id);

                    if ( fIndex > -1) {
                        this.data[fIndex] = {
                            ...this.data[fIndex],
                            ...tip
                        };
                        this.data[fIndex].settled = tip.settled;
                    }                    
                    
                }
                
            });
            this.sockets.subscribe('UpdateUserOnlineStatus', ({onlineUsers, offlineUsers}) => {
                for (let i=0; i < this.data.length; i++) {
                    if (onlineUsers.includes(this.data[i].userId)){
                        this.data[i].online = true;
                        this.online = true;
                    }
                    else
                        this.data[i].online = false;
                    this.data[i].online_refreshKey = this.create_UUID();
                }
            });
            /** cash out */
            this.cashOutTimer = setInterval(this.updateCashOut, 16 * 1000);
            // this.check_cashOutTimer = setInterval(this.checkCashOut, 13 * 1000);
        },
        created() {
        },
        beforeDestroy() {
            this.sockets.unsubscribe('new-comment');
            clearInterval(this.cashOutTimer);
            // clearInterval(this.check_cashOutTimer);
        }
    }
</script>

<style lang="scss" scoped>
   .user-stat-page-container {
       .stat {
           display: flex;
           justify-content: space-between;
           margin-bottom: 20px;
           div {
               text-align: center;
           }
           .username {
               div {
                   text-align: left;
               }
               
                .parent_avatar > .vue-avatar--wrapper {
                        display: inline-flex !important;
                        margin-right: 5px;
                        border: 5px solid white !important;
                }
               
               
           }
       }
       .username{
           ::v-deep .d-flex{
               .parent_avatar{
                   .vue-avatar--wrapper{
                       border: 5px solid white !important;
                   }
               }
           }
       }
       .header {
           .header-item {
                display: flex;
                justify-content: space-between;
                position: relative;
                div {
                    display: flex;
                }
                .settled-lost {
                    font-weight: 700;
                    color: #FF0000;
                }
                .settled-won {
                    font-weight: 700;
                    color: #00FF00;
                }
           }
       }
       .unread-mark {
           top: 0px;
           left: 0px;
       }
       .note-box {
           position: relative;
           margin-bottom: 20px;
           .note {
               padding: 5px;
               margin: 0 0 10px;
               min-height: 70px;
               background-color: #FEE;
               border-radius: 6px;
           }
           .action-box {
               display: flex;
               .action {
                   border-radius: 5px;
                   padding: 0 5px;
                   margin-right: 10px;
                   min-width: 70px;
                   text-align: center;
                   background-color: rgba(0,0,0,0.1);
                   &.selected {
                       background-color: #39F;
                       color: #FFF;
                   }
               }
           }
       }
       .comments {
           padding: 0 0 0 40px;
           .comment {
               position: relative;
               .comment-header {
                   display: flex;
                   align-items: center;
                   .vue-avatar--wrapper {
                       margin-right: 15px;
                   }
               }
                p {
                    padding-left: 45px;
                }
           }
       }
       .post-comment {
           text-align: right;
           margin-bottom: 10px;
           .btn {
           }
       }
    }   
    .c-callout {
        padding: 1rem;
        margin-top: 50px;
        background-color: #eee !important;
    }
    .stat{
        background-color: #5f9ea0;
        color: white;
        padding: 5px 100px 5px 140px;
        position: relative;
        margin-top: 40px;
    }
    .username{
        position: absolute;
        top: 32px;
        left: 60px;
        z-index: 1000;
    }
    .tip_body{
        background-color: whitesmoke;
    }
    .limegreen {
        color: limegreen
    }
    .red {
        color: red
    }

    .feed_card{
        background-color: #f5f5f5;
        border: 1px solid #d3d3d3;
        border-radius: 5px;
        padding: 20px;
        margin-bottom: 20px;
    }
    
    @media (max-width: 576px){
       .stat{
           padding: 5px !important;
       }
       .username{
        left: 20px;
        top: 32px;

        }
        .stat{
            font-size: 10px !important;
            padding-left: 70px !important;
            padding-right: 10px !important;
        }
        .stat > button {
            font-size: 10px;
            padding: 5px !important;
        }        
    } 
</style>
<style>
    @media (max-width: 576px){
        .strategy_stats_button {
            font-size: 8px;
        }
    }
</style>